import React, { useState } from "react";
import { useEffectAsync } from "../../helper/reactHelper";
import Select from "react-select";
import _ from "lodash";

const LinkSelect = ({
    label,
    endpointAll,
    endpointLinked,
    baseId,
    keyBase,
    keyLink,
    keyGetter = (item) => item.id,
    titleGetter = (item) => item.name,
}) => {
    const [active, setActive] = useState(false);
    const [open, setOpen] = useState(false);
    const [items, setItems] = useState();
    const [linked, setLinked] = useState();

    useEffectAsync(async () => {
        if (active) {
            const response = await fetch(endpointAll);
            if (response.ok) {
                setItems(await response.json());
            } else {
                throw Error(await response.text());
            }
        }
    }, [active]);

    useEffectAsync(async () => {
        if (active) {
            const response = await fetch(endpointLinked);
            if (response.ok) {
                const data = await response.json();
                setLinked(
                    data.map((it) => ({
                        value: it.id,
                        label: titleGetter(it),
                    }))
                );
            } else {
                throw Error(await response.text());
            }
        }
    }, [active]);

    const createBody = (linkItem) => {
        const body = {};
        body[keyBase] = baseId;
        body[keyLink] = linkItem.value;
        return body;
    };

    const onChange = async (selected) => {
        const oldValue = linked;
        const newValue = selected;
        if (!newValue.find((it) => it < 0)) {
            const results = [];
            newValue
                .filter((it) => !oldValue.includes(it))
                .forEach((added) => {
                    results.push(
                        fetch("/api/permissions", {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify(createBody(added)),
                        })
                    );
                });
            oldValue
                .filter((it) => !newValue.includes(it))
                .forEach((removed) => {
                    results.push(
                        fetch("/api/permissions", {
                            method: "DELETE",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify(createBody(removed)),
                        })
                    );
                });
            await Promise.all(results);
            setLinked(newValue);
        }
    };

    const style = {
        label: {
            fontSize: ".75rem",
            fontWeight: "bold",
            lineHeight: 2,
        },
    };

    return (
        <form onSubmit={(e) => e.preventDefault()}>
            <label style={style.label}>{label}</label>
            <div onKeyDown={(e) => e.stopPropagation()}>
                <Select
                    placeholder={label}
                    isMulti
                    closeMenuOnSelect={false}
                    onMenuOpen={() => {
                        setActive(true);
                        setOpen(true);
                    }}
                    onMenuClose={() => setOpen(false)}
                    menuIsOpen={open}
                    value={linked || []}
                    onChange={(selected) => onChange(selected)}
                    options={_.map(items, (item) => ({ value: keyGetter(item), label: titleGetter(item) }))}></Select>
            </div>
        </form>
    );
};

export default LinkSelect;
